import api from "services/api";

// Get all milestones for a project
export const getMilestones = async (projectId) => {
  return api.get("/v1/api/milestones/get", {
    params: { project_id: projectId },
  });
};

// Create a new milestone
export const createMilestone = async (milestoneData) => {
  return api.post("/v1/api/milestones/create", milestoneData);
};

export const updateMilestone = async (milestoneId, milestoneData) => {
  return api.patch(`/v1/api/milestones/update/${milestoneId}`, milestoneData);
};

// Get details for a single milestone
export const getMilestoneDetails = async (milestoneId) => {
  return api.get(`/v1/api/milestones/details/${milestoneId}`);
};
